import React from "react";

const NailArtDesign = () => {
  return (
    <div className="salonXpContainer">
      <h5>Nail Art and Custom Designs</h5>
      <p>
        In addition to offering the{" "}
        <a href="https://scentlifestyle.com/nails-salon">
          best nail extension in Bangalore
        </a>
        , SCENT  also specializes in custom nail art and designs. Whether
        you want something simple and elegant or bold and intricate, our
        talented technicians can bring your vision to life. Express your
        personality through your nails with unique designs that make a
        statement.
      </p>
    </div>
  );
};

export default NailArtDesign;
